import { Link } from "react-router-dom";
import { featuredArticles } from "../../../mocks/news";

export default function ExclusiveBand() {
  const dujia = featuredArticles.filter((a) => a.category === "dujia");
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6">
      <div className="relative overflow-hidden rounded-xl bg-primary-600">
        <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-400/20" aria-hidden />
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-72 w-72 rounded-full bg-foreground-950/10" aria-hidden />
        <div className="relative grid grid-cols-1 gap-6 p-6 md:grid-cols-[auto_1fr_auto] md:items-center md:p-10">
          <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-accent-400 text-secondary-900">
            <i className="ri-flashlight-fill text-4xl" />
          </div>
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-focus-3-line" /> 第一现场 · 深度追踪
            </span>
            <h3 className="mt-3 font-serif text-2xl font-black leading-tight text-background-50 md:text-3xl">
              独家首发
              <span className="text-accent-300">猛料 · 内幕 · 还原</span>
            </h3>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-100/90">
              我们不止追热点，更愿意把一个热点背后的来龙去脉讲清楚。独家首发栏目，聚焦第一手线索与调查性内容，不标题党、不空转，尽量还原你想知道的那一层。
            </p>
          </div>
          <div className="flex flex-col gap-3">
            {dujia.length > 0 && (
              <>
                {dujia.slice(0, 2).map((a) => (
                  <Link
                    key={a.slug}
                    to={`/news/${a.slug}`}
                    className="rounded-lg bg-background-50/10 p-3 backdrop-blur transition-colors hover:bg-background-50/20"
                  >
                    <span className="line-clamp-2 text-sm font-medium text-background-50">{a.title}</span>
                    <span className="mt-1 flex items-center gap-1 text-xs text-accent-300">
                      查看独家 <i className="ri-arrow-right-line" />
                    </span>
                  </Link>
                ))}
              </>
            )}
            <Link
              to="/category/dujia"
              className="inline-flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md bg-accent-400 px-4 py-2.5 text-sm font-bold text-secondary-900 transition-colors hover:bg-accent-300"
            >
              进入独家首发 <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}